module.exports = __webpack_public_path__ + "static/media/delivery.8ca28be0.png";